import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReferralTelegram = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 50,
	height: 50,
	viewBox: "0 0 50 50",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 25,
		cy: 25,
		r: 24.5,
		fill: "white",
		stroke: "white"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M33.014 16.1184L33.22 16.5739C33.5129 16.4414 33.7072 16.5084 33.8034 16.6013C33.9062 16.7007 34.0438 16.9724 33.9035 17.535L33.9014 17.5436L33.8995 17.5522L30.6623 32.8088L30.6619 32.8106C30.5627 33.2864 30.4 33.4309 30.308 33.4723C30.2153 33.514 30.0112 33.5342 29.6319 33.3315L24.7284 29.7096L24.387 29.4575L24.0827 29.7533L21.7132 32.0575L21.712 32.0587C21.6802 32.0894 21.6516 32.1169 21.6254 32.1419L21.895 28.1136L30.8914 19.9944C30.892 19.9939 30.8926 19.9933 30.8932 19.9928C31.0216 19.8784 31.1962 19.6819 31.2064 19.4112C31.2122 19.2576 31.1618 19.1095 31.063 18.9918C30.9709 18.882 30.8568 18.8218 30.762 18.7893C30.5783 18.7262 30.3814 18.7357 30.2158 18.77C30.0407 18.8063 29.8569 18.879 29.6787 18.9874L29.6787 18.9874L29.6718 18.9917L18.5737 25.9939L13.913 24.54L13.9108 24.5393C13.6902 24.4716 13.5714 24.3961 13.5186 24.3462C13.5163 24.344 13.5142 24.342 13.5123 24.3401C13.5259 24.3195 13.5519 24.2869 13.6009 24.2436C13.7091 24.1479 13.8954 24.0316 14.1854 23.9149L33.1938 16.5849L33.014 16.1184ZM13.494 24.3187C13.4941 24.3187 13.4943 24.319 13.4946 24.3197L13.494 24.3187Z",
		fill: "black",
		stroke: "black"
	})]
});
export default SvgReferralTelegram;
